// extracted by mini-css-extract-plugin
module.exports = {"totalTitle":"OrderHistoryTile_totalTitle__3MrKG","paymentIcon":"OrderHistoryTile_paymentIcon__3h_uE"};